import Timer from './Timer';
import Game from 'Game';
import { TimerType } from '../TimerTypes';
import DateHelper from 'Utility/DateHelper';
import { TimerActions } from 'State/Timer/TimerActions';
import { IGameState } from 'State/Game/IGameState';
import TimerStateHelper from 'State/Timer/TimerStateHelper';

export const FARM_MINI_GAME_TIMER_DURATION = DateHelper.HalfDay;

export default class FarmMiniGameTimer extends Timer {
    public complete(): void {
        TimerActions.updateTimer({
            timer: TimerType.FARM_MINI_GAME,
            time: null,
        });
        this.onComplete();
    }
    public onComplete(): void {}
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        return TimerStateHelper.isTimerComplete(
            state,
            TimerType.FARM_MINI_GAME,
            FARM_MINI_GAME_TIMER_DURATION
        );
    }
    public getDuration(): { duration: number; format: string } {
        return { duration: FARM_MINI_GAME_TIMER_DURATION, format: 'hh:mm:ss' };
    }

    public getDate(state: IGameState = Game.store.getState()): Date {
        return state.playerState.timers.get(TimerType.FARM_MINI_GAME);
    }
}
